import { render } from "./ComplementsCapillairesH.vue?vue&type=template&id=ffbfc4e8&scoped=true"
import script from "./ComplementsCapillairesH.vue?vue&type=script&lang=js"
export * from "./ComplementsCapillairesH.vue?vue&type=script&lang=js"

import "./ComplementsCapillairesH.vue?vue&type=style&index=0&id=ffbfc4e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbfc4e8"]])

export default __exports__